const breakpoints = {
    mid: 820,
    small: 600,
    smaller: 430
}

export default breakpoints
